import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { db } from '../firebase/config';
import { collection, query, getDocs } from 'firebase/firestore';
import { CircularProgress, Box } from '@mui/material';

const InitialSetupGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [needsSetup, setNeedsSetup] = useState(false);

  useEffect(() => {
    checkInitialSetup();
  }, []);

  const checkInitialSetup = async () => {
    try {
      // Vérifier si un super admin existe
      const usersQuery = query(collection(db, 'users'));
      const querySnapshot = await getDocs(usersQuery);
      
      setNeedsSetup(querySnapshot.empty);
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors de la vérification de la configuration:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Si la configuration initiale est nécessaire, rediriger vers /setup
  if (needsSetup) {
    return <Navigate to="/setup" replace />;
  }

  // Sinon, afficher les enfants (le contenu normal de l'application)
  return children;
};

export default InitialSetupGuard;
